export const defaultStrings = {

  sale_button_login_label : "See special pricing"


}



// WEBPACK FOOTER //
// ./resources/js/data/strings.js